module.exports = __webpack_public_path__ + "static/media/3.52922c06.PNG";